module.exports = __webpack_public_path__ + "static/media/cancel.51984023.svg";